export const times = [
  {
    id: 1,
    time: "8:00",
  },
  {
    id: 2,
    time: "8:15",
  },
  {
    id: 3,
    time: "8:30",
  },
  {
    id: 4,
    time: "8:45",
  },
  {
    id: 5,
    time: "9:00",
  },
  {
    id: 6,
    time: "9:15",
  },
  {
    id: 7,
    time: "9:30",
  },
  {
    id: 8,
    time: "9:45",
  },
  {
    id: 9,
    time: "10:00",
  },
  {
    id: 10,
    time: "10:15",
  },
  {
    id: 11,
    time: "10:30",
  },
  {
    id: 12,
    time: "10:45",
  },
  {
    id: 13,
    time: "11:00",
  },
  {
    id: 15,
    time: "11:15",
  },
  {
    id: 16,
    time: "11:30",
  },
  {
    id: 17,
    time: "11:45",
  },
  {
    id: 18,
    time: "12:00",
  },
  {
    id: 19,
    time: "12:15",
  },
  {
    id: 20,
    time: "12:30",
  },
  {
    id: 21,
    time: "12:45",
  },
  {
    id: 22,
    time: "13:00",
  },
  {
    id: 23,
    time: "13:15",
  },
  {
    id: 24,
    time: "13:30",
  },
  {
    id: 25,
    time: "13:45",
  },
  {
    id: 26,
    time: "14:00",
  },
  {
    id: 27,
    time: "14:15",
  },
  {
    id: 28,
    time: "14:30",
  },
  {
    id: 29,
    time: "14:45",
  },
  {
    id: 30,
    time: "15:00",
  },
  {
    id: 31,
    time: "15:15",
  },
  {
    id: 32,
    time: "15:30",
  },
  {
    id: 33,
    time: "15:45",
  },
  {
    id: 34,
    time: "16:00",
  },
  {
    id: 35,
    time: "16:15",
  },
  {
    id: 36,
    time: "16:30",
  },
  {
    id: 37,
    time: "16:45",
  },
  {
    id: 38,
    time: "17:00",
  },
  {
    id: 39,
    time: "17:15",
  },
  {
    id: 40,
    time: "17:30",
  },
  {
    id: 41,
    time: "17:45",
  },
  {
    id: 42,
    time: "18:00",
  },
  {
    id: 43,
    time: "18:15",
  },
  {
    id: 44,
    time: "18:30",
  },
  {
    id: 45,
    time: "18:45",
  },
  {
    id: 46,
    time: "19:00",
  },
  {
    id: 47,
    time: "19:15",
  },
  {
    id: 48,
    time: "19:30",
  },
  {
    id: 49,
    time: "19:45",
  },
  {
    id: 50,
    time: "20:00",
  },
  {
    id: 51,
    time: "20:15",
  },
  {
    id: 52,
    time: "20:30",
  },
  {
    id: 53,
    time: "20:45",
  }
];